export default __webpack_public_path__ + "static/media/03.931a79af.png";